import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute } from '@angular/router';
import { Ladder } from 'src/models/ladder.model';

const TWELVE_WEEKS = 12 * 7 * 24 * 60 * 60 * 1000;

@Component({
  selector: 'admin-addladder',
  templateUrl: './addladder.component.html',
})
export class AdminAddLadderComponent {
  public fg: FormGroup;

  public ladderId: FormControl = new FormControl('',Validators.required);
  public name: FormControl = new FormControl('',Validators.required);
  public startDate: FormControl = new FormControl('',Validators.required);
  public endDate: FormControl = new FormControl('',Validators.required);
  public forfeitPoints: FormControl = new FormControl('4',Validators.required);
  public type: FormControl = new FormControl('Normal',Validators.required);

  constructor(private http: HttpClient,
    private aRoute: ActivatedRoute,
  private fb: FormBuilder) {

    this.fg = fb.group({
      ladderId: this.ladderId,
      name: this.name,
      startDate: this.startDate,
      endDate: this.endDate,
      forfeitPoints: this.forfeitPoints,
      type: this.type
    });


      const d = new Date();
      this.startDate.setValue(d);
      this.setToDate(d);

      this.http.get<Ladder[]>('/ladders').subscribe(
            (resp) => {
              const year = new Date().getFullYear().toString();
              const a = this.parseYearString(resp[0].ladderId);

              if( a.year == year) {
                this.ladderId.setValue(a.year+'-'+(a.n+1));
              }
              else {
                // if we are in a new year
                this.ladderId.setValue(year+'-1');
              }
            }
          )

     this.name.setValue(new Date().getFullYear().toString() + ' ' + this.getCurrentSeason())
  }

  private parseYearString(yearStr: string): { year: string, n: number} {
    const match = yearStr.match(/^(\d{4})-(\d+)$/);
    if (match) {
      const year = match[1]; // The first capturing group (the four digits)
      const numberAfterDash = match[2]; // The second capturing group (digits after the dash)
      return { year, n: parseInt(numberAfterDash,10) };
    } else {
      return null; // Or throw an error, depending on how you want to handle invalid formats
    }
  }

  public dateChange(evt: any) {
    //console.log('the date picked is ', evt.value);
    this.setToDate(evt.value);
  }

  public setToDate(d:Date) {
    this.endDate.setValue(new Date(d.getTime() + TWELVE_WEEKS));
  }

  private getCurrentSeason() {
    // Create a new Date object to get the current date and time.
    const currentDate = new Date();
    // getMonth() returns the month as a zero-based index (0 for January, 11 for December).
    const month = currentDate.getMonth();

    let season;

    // Determine the season based on the month
    // Winter: November (10), December (11), January (0)
    if (month === 10 || month === 11 || month === 0) {
        season = "Winter";
    }
    // Spring: February (1), March (2), April (3)
    else if (month >= 1 && month <= 3) {
        season = "Spring";
    }
    // Summer: May (4), June (5), July (6)
    else if (month >= 4 && month <= 6) {
        season = "Summer";
    }
    // Fall: August (7), September (8), October (9)
    else if (month >= 7 && month <= 9) {
        season = "Fall";
    }
    // This case should ideally not be reached if all months are covered,
    // but included for robustness.
    else {
        season = "Unknown Season";
    }

    return season;
}

public busy: boolean = false;
public msg: string = '';
public submit(evt:any) {
  const x = this.fg.value;
  this.busy = true;
  this.http.post('/ladder/create', x).subscribe(
    (resp: any) => {
      this.busy = false;
      console.log('created ladder id ', resp.id)
      this.msg = `Successfully created ladder ${resp.ladderId} db id ${resp.id}`;
    },
    (err: any) => 
    {
      this.busy = false;
      this.msg = `FAILED ~ ${err.error}`;
    }
  )
}
}
